import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Button } from '@clds/button';
import { removeCustomerIdAndReload } from '@cld/session-service';
import { SomethingWentWrong } from '@cld/empty-state';
import { messages } from '../../i18n';

// istanbul ignore next
export const CustomerNotFound: FC<React.PropsWithChildren<{ isMobile?: boolean }>> = ({ isMobile }) => {
  const { formatMessage } = useIntl();

  return (
    <SomethingWentWrong isMobile={isMobile} title={formatMessage(messages.invalidCustomerTitle)}>
      <StyledButton tone="plain" onClick={removeCustomerIdAndReload}>
        {formatMessage(messages.invalidCustomerAction)}
      </StyledButton>
    </SomethingWentWrong>
  );
};

const StyledButton = styled(Button)`
  justify-content: center;
`;
